// class ScrollSnapSlider extends HTMLUListElement {
//   constructor() {
//     super();
    
//     this.prevButton = this.parentNode.querySelector(".slider-buttons .slider-button--prev");
//     this.nextButton = this.parentNode.querySelector(".slider-buttons .slider-button--next");
//     this.indicators = this.parentNode.querySelectorAll(".indicator");
//     this.currentIndicator = this.parentNode.querySelector(".indicator .current-indicator");
//     this.isAutoplay = (this.dataset.autoplay || "false") === 'true';
//     this.isLoop = (this.dataset.loop || "false") === 'true';
//     this.isDraggable = (this.dataset.draggable || "false") === 'true';
//     this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3000;

//     theme.initWhenVisible({
//       element: this,
//       callback: this.init.bind(this),
//       threshold: 200
//     });
//   }

//   async init() {
//     const { ScrollSnapSlider, ScrollSnapDraggable, ScrollSnapAutoplay, ScrollSnapLoop } = await import('mdl-scrollsnap');

//     const sliderElement = this;
//     const sliderSimple = new ScrollSnapSlider({ element: this });
//     const draggablePlugin = new ScrollSnapDraggable(70);
//     const autoplayPlugin = new ScrollSnapAutoplay(this.autoplayInterval);
//     const loopPlugin = new ScrollSnapLoop();
    
//     this.slider = sliderSimple;

//     draggablePlugin.slider = sliderSimple;
//     autoplayPlugin.slider = sliderSimple;
//     loopPlugin.slider = sliderSimple;

//     this.prevButton?.addEventListener("click", () => {
//       autoplayPlugin.disableTemporarily();
//       sliderSimple.slideTo(sliderSimple.slide - 1);
//     });
//     this.nextButton?.addEventListener("click", () => {
//       autoplayPlugin.disableTemporarily();
//       sliderSimple.slideTo(sliderSimple.slide + 1);
//     });

//     for (const indicator of this.indicators) {
//       indicator.addEventListener("click", function () {
//         autoplayPlugin.disableTemporarily();
//         const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex(item => item.dataset.index === indicator.dataset.index);
//         sliderSimple.slideTo(slideElementIndex);
//       });
//     }

//     this.slider.addEventListener("slide-stop", (e) => {
//       this.updateSlideState(e);
//       this.updateIndicator(e);
//     });

//     if (!this.isLoop || this.isDraggable) {
//       this.slider.addEventListener("slide-stop", () => {
//         this.prevButton?.removeAttribute('disabled');
//         this.nextButton?.removeAttribute('disabled');
//         if (sliderSimple.firstItemInView) {
//           this.prevButton?.setAttribute('disabled', 'disabled');
//         }
//         if (sliderSimple.lastItemInView) {
//           this.nextButton?.setAttribute('disabled', 'disabled');
//         }
//       });
//     }

//     if (this.isAutoplay) {
//       this.enablePlugin(autoplayPlugin);
//     }

//     if (this.isLoop) {
//       this.enablePlugin(loopPlugin);
//     }

//     if (this.isDraggable) {
//       this.enablePlugin(draggablePlugin);
//       if (this.isLoop) {
//         this.disablePlugin(loopPlugin);
//       }
//       return;
//     }
//     this.disablePlugin(draggablePlugin);
//   }

//   slideTo(index) {
//     this.slider.slideTo(index);
//   }

//   enablePlugin(plugin) {
//     plugin.enable();
//     this.slider.plugins.set(plugin.id, plugin);
//   }

//   disablePlugin(plugin) {
//     plugin.disable();
//     this.slider.plugins.delete(plugin.id);
//   }

//   updateSlideState(event) {
//     const children = event.target.children; 
//       if (!children || event.detail < 0 || event.detail >= children.length) {
//         return; 
//       }
//       for (let child of children) {
//         child.classList.remove('-active');
//       }
//       children[event.detail].classList.add('-active');
//   }

//   updateIndicator(event) {
//     const slideElementIndex = event.detail;
//     const slideElement = event.target.children[slideElementIndex];

//     for (const indicator of this.indicators) {
//       const isActive = indicator.classList.toggle(
//       "-active",
//       indicator.dataset.index === slideElement.dataset.index);
  
//       if (isActive) {
//         indicator.appendChild(this.currentIndicator);
//       }
//     }
//   }
// }
// customElements.define('scroll-snap-slider', ScrollSnapSlider, { extends: 'ul' });
// // class ScrollSnapSlider extends HTMLUListElement {
// //   constructor() {
// //     super();
    
// //     this.prevButton = this.parentNode.querySelector(".slider-buttons .slider-button--prev");
// //     this.nextButton = this.parentNode.querySelector(".slider-buttons .slider-button--next");
// //     this.indicators = this.parentNode.querySelectorAll(".indicator");
// //     this.currentIndicator = this.parentNode.querySelector(".indicator .current-indicator");
// //     this.isAutoplay = (this.dataset.autoplay || "false") === 'true';
// //     this.isLoop = (this.dataset.loop || "false") === 'true';
// //     this.isDraggable = (this.dataset.draggable || "false") === 'true';
// //     this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3000;

// //     theme.initWhenVisible({
// //       element: this,
// //       callback: this.init.bind(this),
// //       threshold: 200
// //     });
// //   }

// //   async init() {
// //     const { ScrollSnapSlider, ScrollSnapDraggable, ScrollSnapAutoplay, ScrollSnapLoop } = await import('mdl-scrollsnap');

// //     const sliderElement = this;
// //     const sliderSimple = new ScrollSnapSlider({ element: this });
// //     const draggablePlugin = new ScrollSnapDraggable(70);
// //     const autoplayPlugin = new ScrollSnapAutoplay(this.autoplayInterval);
// //     const loopPlugin = new ScrollSnapLoop();
    
// //     this.slider = sliderSimple;

// //     draggablePlugin.slider = sliderSimple;
// //     autoplayPlugin.slider = sliderSimple;
// //     loopPlugin.slider = sliderSimple;

// //     this.prevButton?.addEventListener("click", () => {
// //       autoplayPlugin.disableTemporarily();
// //       sliderSimple.slideTo(sliderSimple.slide - 1);
// //     });
// //     this.nextButton?.addEventListener("click", () => {
// //       autoplayPlugin.disableTemporarily();
// //       sliderSimple.slideTo(sliderSimple.slide + 1);
// //     });

// //     for (const indicator of this.indicators) {
// //       indicator.addEventListener("click", function () {
// //         autoplayPlugin.disableTemporarily();
// //         const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex(item => item.dataset.index === indicator.dataset.index);
// //         sliderSimple.slideTo(slideElementIndex);
// //       });
// //     }

// //     this.slider.addEventListener("slide-stop", (e) => {
// //       this.updateSlideState(e);
// //       this.updateIndicator(e);
// //     });

// //     if (!this.isLoop || this.isDraggable) {
// //       this.slider.addEventListener("slide-stop", () => {
// //         this.prevButton?.removeAttribute('disabled');
// //         this.nextButton?.removeAttribute('disabled');
// //         if (sliderSimple.firstItemInView) {
// //           this.prevButton?.setAttribute('disabled', 'disabled');
// //         }
// //         if (sliderSimple.lastItemInView) {
// //           this.nextButton?.setAttribute('disabled', 'disabled');
// //         }
// //       });
// //     }

// //     if (this.isAutoplay) {
// //       this.enablePlugin(autoplayPlugin);
// //     }

// //     if (this.isLoop) {
// //       this.enablePlugin(loopPlugin);
// //     }

// //     if (this.isDraggable) {
// //       this.enablePlugin(draggablePlugin);
// //       if (this.isLoop) {
// //         this.disablePlugin(loopPlugin);
// //       }
// //       return;
// //     }
// //     this.disablePlugin(draggablePlugin);
// //   }

// //   slideTo(index) {
// //     this.slider.slideTo(index);
// //   }

// //   enablePlugin(plugin) {
// //     plugin.enable();
// //     this.slider.plugins.set(plugin.id, plugin);
// //   }

// //   disablePlugin(plugin) {
// //     plugin.disable();
// //     this.slider.plugins.delete(plugin.id);
// //   }

// //   updateSlideState(event) {
// //     const children = event.target.children; 
// //       if (!children || event.detail < 0 || event.detail >= children.length) {
// //         return; 
// //       }
// //       for (let child of children) {
// //         child.classList.remove('-active');
// //       }
// //       children[event.detail].classList.add('-active');
// //   }

// //   updateIndicator(event) {
// //     const slideElementIndex = event.detail;
// //     const slideElement = event.target.children[slideElementIndex];

// //     for (const indicator of this.indicators) {
// //       const isActive = indicator.classList.toggle(
// //       "-active",
// //       indicator.dataset.index === slideElement.dataset.index);
  
// //       if (isActive) {
// //         indicator.appendChild(this.currentIndicator);
// //       }
// //     }
// //   }
// // }
// // customElements.define('scroll-snap-slider', ScrollSnapSlider, { extends: 'ul' });
// class ScrollSnapSlider extends HTMLUListElement {
//   constructor() {
//     super();
    
//     this.prevButton = this.parentNode.querySelector(".slider-buttons .slider-button--prev");
//     this.nextButton = this.parentNode.querySelector(".slider-buttons .slider-button--next");
//     this.indicators = this.parentNode.querySelectorAll(".indicator");
//     this.currentIndicator = this.parentNode.querySelector(".indicator .current-indicator");
//     this.isAutoplay = (this.dataset.autoplay || "false") === 'true';
//     this.isLoop = (this.dataset.loop || "false") === 'true';
//     this.isDraggable = (this.dataset.draggable || "false") === 'true';
//     this.isRtl = (this.dataset.rtl || "false") === 'true' || document.dir === 'rtl' || getComputedStyle(this).direction === 'rtl';
//     this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3000;

//     theme.initWhenVisible({
//       element: this,
//       callback: this.init.bind(this),
//       threshold: 200
//     });
//   }

//   async init() {
//     const { ScrollSnapSlider, ScrollSnapDraggable, ScrollSnapAutoplay, ScrollSnapLoop } = await import('mdl-scrollsnap');

//     const sliderElement = this;
//     const sliderSimple = new ScrollSnapSlider({ element: this });
//     const draggablePlugin = new ScrollSnapDraggable(70);
//     const autoplayPlugin = new ScrollSnapAutoplay(this.autoplayInterval);
//     const loopPlugin = new ScrollSnapLoop();
    
//     this.slider = sliderSimple;

//     draggablePlugin.slider = sliderSimple;
//     autoplayPlugin.slider = sliderSimple;
//     loopPlugin.slider = sliderSimple;

//     // RTL support: Swap button functionality
//     const prevAction = () => {
//       autoplayPlugin.disableTemporarily();
//       const direction = this.isRtl ? 1 : -1;
//       sliderSimple.slideTo(sliderSimple.slide + direction);
//     };

//     const nextAction = () => {
//       autoplayPlugin.disableTemporarily();
//       const direction = this.isRtl ? -1 : 1;
//       sliderSimple.slideTo(sliderSimple.slide + direction);
//     };

//     this.prevButton?.addEventListener("click", prevAction);
//     this.nextButton?.addEventListener("click", nextAction);

//     for (const indicator of this.indicators) {
//       indicator.addEventListener("click", function () {
//         autoplayPlugin.disableTemporarily();
//         const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex(item => item.dataset.index === indicator.dataset.index);
//         sliderSimple.slideTo(slideElementIndex);
//       });
//     }

//     this.slider.addEventListener("slide-stop", (e) => {
//       this.updateSlideState(e);
//       this.updateIndicator(e);
//     });

//     if (!this.isLoop || this.isDraggable) {
//       this.slider.addEventListener("slide-stop", () => {
//         this.prevButton?.removeAttribute('disabled');
//         this.nextButton?.removeAttribute('disabled');
        
//         // RTL support: Swap first/last item logic for buttons
//         if (this.isRtl) {
//           if (sliderSimple.lastItemInView) {
//             this.prevButton?.setAttribute('disabled', 'disabled');
//           }
//           if (sliderSimple.firstItemInView) {
//             this.nextButton?.setAttribute('disabled', 'disabled');
//           }
//         } else {
//           if (sliderSimple.firstItemInView) {
//             this.prevButton?.setAttribute('disabled', 'disabled');
//           }
//           if (sliderSimple.lastItemInView) {
//             this.nextButton?.setAttribute('disabled', 'disabled');
//           }
//         }
//       });
//     }

//     if (this.isAutoplay) {
//       this.enablePlugin(autoplayPlugin);
//       // RTL support: Reverse autoplay direction
//       if (this.isRtl && autoplayPlugin.direction) {
//         autoplayPlugin.direction = -1;
//       }
//     }

//     if (this.isLoop) {
//       this.enablePlugin(loopPlugin);
//     }

//     if (this.isDraggable) {
//       this.enablePlugin(draggablePlugin);
//       if (this.isLoop) {
//         this.disablePlugin(loopPlugin);
//       }
//       return;
//     }
//     this.disablePlugin(draggablePlugin);
//   }

//   slideTo(index) {
//     this.slider.slideTo(index);
//   }

//   enablePlugin(plugin) {
//     plugin.enable();
//     this.slider.plugins.set(plugin.id, plugin);
//   }

//   disablePlugin(plugin) {
//     plugin.disable();
//     this.slider.plugins.delete(plugin.id);
//   }

//   updateSlideState(event) {
//     const children = event.target.children; 
//       if (!children || event.detail < 0 || event.detail >= children.length) {
//         return; 
//       }
//       for (let child of children) {
//         child.classList.remove('-active');
//       }
//       children[event.detail].classList.add('-active');
//   }

//   updateIndicator(event) {
//     const slideElementIndex = event.detail;
//     const slideElement = event.target.children[slideElementIndex];

//     for (const indicator of this.indicators) {
//       const isActive = indicator.classList.toggle(
//       "-active",
//       indicator.dataset.index === slideElement.dataset.index);
  
//       if (isActive) {
//         indicator.appendChild(this.currentIndicator);
//       }
//     }
//   }
// }
// customElements.define('scroll-snap-slider', ScrollSnapSlider, { extends: 'ul' });
class ScrollSnapSlider extends HTMLUListElement {
  constructor() {
    super();
    
    this.prevButton = this.parentNode.querySelector(".slider-buttons .slider-button--prev");
    this.nextButton = this.parentNode.querySelector(".slider-buttons .slider-button--next");
    this.indicators = this.parentNode.querySelectorAll(".indicator");
    this.currentIndicator = this.parentNode.querySelector(".indicator .current-indicator");
    this.isAutoplay = (this.dataset.autoplay || "false") === 'true';
    this.isLoop = (this.dataset.loop || "false") === 'true';
    this.isDraggable = (this.dataset.draggable || "false") === 'true';
    
    // RTL Detection - Multiple methods
    this.isRtl = this.detectRTL();
    
    this.autoplayInterval = this.dataset.autoplayInterval ? this.dataset.autoplayInterval : 3000;
    this.scrollTimeout = null; // Scroll timeout ke liye

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  detectRTL() {
    // Method 1: Check data attribute
    if (this.dataset.rtl === 'true') return true;
    
    // Method 2: Check document direction
    if (document.documentElement.dir === 'rtl' || document.body.dir === 'rtl') return true;
    
    // Method 3: Check computed style
    const computedDir = getComputedStyle(this).direction;
    if (computedDir === 'rtl') return true;
    
    // Method 4: Check parent containers
    let parent = this.parentElement;
    while (parent) {
      if (parent.dir === 'rtl' || getComputedStyle(parent).direction === 'rtl') return true;
      parent = parent.parentElement;
    }
    
    return false;
  }

  async init() {
    const { ScrollSnapSlider, ScrollSnapDraggable, ScrollSnapAutoplay, ScrollSnapLoop } = await import('mdl-scrollsnap');

    const sliderElement = this;
    const sliderSimple = new ScrollSnapSlider({ element: this });
    const draggablePlugin = new ScrollSnapDraggable(70);
    const autoplayPlugin = new ScrollSnapAutoplay(this.autoplayInterval);
    const loopPlugin = new ScrollSnapLoop();
    
    this.slider = sliderSimple;

    draggablePlugin.slider = sliderSimple;
    autoplayPlugin.slider = sliderSimple;
    loopPlugin.slider = sliderSimple;

    // RTL Support: Button click handlers
    this.prevButton?.addEventListener("click", () => {
      autoplayPlugin.disableTemporarily();
      // RTL mein prev button next ki tarah kaam karega
      const slideIndex = this.isRtl ? sliderSimple.slide + 1 : sliderSimple.slide - 1;
      sliderSimple.slideTo(slideIndex);
    });

    this.nextButton?.addEventListener("click", () => {
      autoplayPlugin.disableTemporarily();
      // RTL mein next button prev ki tarah kaam karega
      const slideIndex = this.isRtl ? sliderSimple.slide - 1 : sliderSimple.slide + 1;
      sliderSimple.slideTo(slideIndex);
    });

    // Indicator click handlers
    for (const indicator of this.indicators) {
      indicator.addEventListener("click", function () {
        autoplayPlugin.disableTemporarily();
        const slideElementIndex = Array.prototype.slice.call(sliderElement.children).findIndex(item => item.dataset.index === indicator.dataset.index);
        sliderSimple.slideTo(slideElementIndex);
      });
    }

    // Slide stop event listeners
    this.slider.addEventListener("slide-stop", (e) => {
      this.updateSlideState(e);
      this.updateIndicator(e);
      
      // Button states ko bhi update karo (loop mode ke ilawa)
      if (!this.isLoop) {
        // Thoda delay de taake slide complete ho jaye
        setTimeout(() => {
          this.updateButtonStates(sliderSimple);
        }, 50);
      }
    });

    // Additional scroll event listener for better detection
    if (!this.isLoop) {
      this.addEventListener("scroll", () => {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          this.updateButtonStates(sliderSimple);
        }, 150);
      });
    }

    // Enable plugins based on settings
    if (this.isAutoplay) {
      this.enablePlugin(autoplayPlugin);
      // RTL mein autoplay direction reverse karo
      if (this.isRtl) {
        // Note: mdl-scrollsnap library ki configuration check karni hogi
        // Agar library support karti hai toh:
        autoplayPlugin.reverse = true;
      }
    }

    if (this.isLoop) {
      this.enablePlugin(loopPlugin);
    }

    if (this.isDraggable) {
      this.enablePlugin(draggablePlugin);
      if (this.isLoop) {
        this.disablePlugin(loopPlugin);
      }
      return;
    }
    this.disablePlugin(draggablePlugin);

    // Initial button state
    this.updateButtonStates(sliderSimple);
  }

  updateButtonStates(sliderSimple) {
    if (!this.prevButton || !this.nextButton) return;

    // Pehle dono buttons enable karo
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');

    // Current scroll position aur container width
    const scrollLeft = Math.abs(this.scrollLeft);
    const scrollWidth = this.scrollWidth;
    const clientWidth = this.clientWidth;
    
    // Calculate threshold (5px tolerance)
    const threshold = 5;
    const isAtStart = scrollLeft <= threshold;
    const isAtEnd = scrollLeft >= (scrollWidth - clientWidth - threshold);

    if (this.isRtl) {
      // RTL mode: Logic reverse hogi
      if (isAtEnd) {
        this.prevButton.setAttribute('disabled', 'disabled');
      }
      if (isAtStart) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
    } else {
      // LTR mode: Normal logic
      if (isAtStart) {
        this.prevButton.setAttribute('disabled', 'disabled');
      }
      if (isAtEnd) {
        this.nextButton.setAttribute('disabled', 'disabled');
      }
    }
  }

  slideTo(index) {
    this.slider.slideTo(index);
  }

  enablePlugin(plugin) {
    plugin.enable();
    this.slider.plugins.set(plugin.id, plugin);
  }

  disablePlugin(plugin) {
    plugin.disable();
    this.slider.plugins.delete(plugin.id);
  }

  updateSlideState(event) {
    const children = event.target.children; 
    if (!children || event.detail < 0 || event.detail >= children.length) {
      return; 
    }
    for (let child of children) {
      child.classList.remove('-active');
    }
    children[event.detail].classList.add('-active');
  }

  updateIndicator(event) {
    const slideElementIndex = event.detail;
    const slideElement = event.target.children[slideElementIndex];

    for (const indicator of this.indicators) {
      const isActive = indicator.classList.toggle(
        "-active",
        indicator.dataset.index === slideElement.dataset.index
      );
  
      if (isActive) {
        indicator.appendChild(this.currentIndicator);
      }
    }
  }
}

customElements.define('scroll-snap-slider', ScrollSnapSlider, { extends: 'ul' });